'use strict';

function WealthEducational() {
  this.id = null;
  this.node = null;
  this.extends = [_WealthController, Educational];

  this.contentId = ''; // 'wealth' (defined in pug file)

  this.init = function () {
    this._super();
    this.initPage();
  };

  this.initPage = function () {
    this.initEducational();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyEducational();
  };
}